import React, { useEffect } from 'react';
import { DefinitionList, Grid } from "react-unity"
import SelectField from "../../../common/form-controls/SelectField"
import TextInputField from "../../../common/form-controls/TextInputField"
import '../../OnPremSiteToSiteVPNRequestsCreate.css';
import { useAbstractStandardSiteToSiteVPNConfigurationForm } from './AbstractStandardSiteToSiteVPNConfigurationForm';
import OnPremSiteToSiteVPNStandardConfiguration from '../../../../models/entities/OnPremSiteToSiteVPNStandardConfiguration';

type Mode = 'create' | 'detail' | 'edit';
interface StandardSiteToSiteVPNConfigurationFormProps {
    standardConfig: OnPremSiteToSiteVPNStandardConfiguration;
    onChange: (config: OnPremSiteToSiteVPNStandardConfiguration) => void;
    operationInProgress: boolean;
    optionSelected: number;
    standardConfigurationData: any;
    mode: Mode;
    disabled?: boolean;
}

const StandardSiteToSiteVPNConfigurationForm = (props: StandardSiteToSiteVPNConfigurationFormProps) => {

    const {
        state,
        formModel,
        getStateFormHandlers,
        isValid,
    } = useAbstractStandardSiteToSiteVPNConfigurationForm({ optionSelected: props.optionSelected, standardConfigurationData: props.standardConfigurationData, onChange: props.onChange, mode: props.mode, standardConfig: props.standardConfig });

    const stateFormHandler = () => getStateFormHandlers();


    const handleStateFormChangeSup = (field: string, event: any) => {
        let { standardConfig } = props;
        stateFormHandler()[field].onChange(event);
        standardConfig = new OnPremSiteToSiteVPNStandardConfiguration(state.stateForm);
        props.onChange(standardConfig);
    }

    const getAvailableOptions = (fieldName) => {
        if (props.mode === 'create') {
            const fieldData = props.standardConfigurationData[fieldName];
            const selectedOption = fieldData.find(option => option.option === `Option${props.optionSelected}`);
            return selectedOption ? selectedOption.availableOptions : [];

        } else {

            const currentValue = props.standardConfig[fieldName];
            const fieldData = props.standardConfigurationData[fieldName];
            const selectedOption = fieldData.find(option => option.option === `Option${props.optionSelected}`);
            const availableOptions = selectedOption ? selectedOption.availableOptions : [];

            const allOptions = new Set([currentValue, ...availableOptions]);
            return Array.from(allOptions);
        }
    };

    const isDisabled = typeof props.disabled === 'boolean'
        ? props.disabled
        : props.operationInProgress || props.mode === 'detail';

    const getSelectValue = (fieldName) => {
        return stateFormHandler()[fieldName].value;
    };

    return (<>
        <Grid.Item>
            <h5>PHASE 1</h5>
            <DefinitionList>
                <DefinitionList.Item>
                    <SelectField
                        label="Phase 1 Encryption Algorithm"
                        className="full-width"
                        {...stateFormHandler().ph1EncrypAlgo}
                        value={getSelectValue('ph1EncrypAlgo')}
                        onChange={(e) => handleStateFormChangeSup('ph1EncrypAlgo', e)}
                        options={getAvailableOptions('ph1EncrypAlgo')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="PRF Algorithm"
                        className="full-width"
                        {...stateFormHandler().ph1PRFAlgo}
                        value={getSelectValue('ph1PRFAlgo')}
                        onChange={(e) => handleStateFormChangeSup('ph1PRFAlgo', e)}
                        options={getAvailableOptions('ph1PRFAlgo')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Diffie-Hillman Group"
                        className="full-width"
                        {...stateFormHandler().ph1DHGroup}
                        value={getSelectValue('ph1DHGroup')}
                        onChange={(e) => handleStateFormChangeSup('ph1DHGroup', e)}
                        options={getAvailableOptions('ph1DHGroup')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Phase 1 Timeout (Lifetime seconds)"
                        className="full-width"
                        {...stateFormHandler().ph1TimeoutSec}
                        value={getSelectValue('ph1TimeoutSec')}
                        onChange={(e) => handleStateFormChangeSup('ph1TimeoutSec', e)}
                        options={getAvailableOptions('ph1TimeoutSec')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="IKE"
                        className="full-width"
                        {...stateFormHandler().ph1IKE}
                        value={getSelectValue('ph1IKE')}
                        onChange={(e) => handleStateFormChangeSup('ph1IKE', e)}
                        options={getAvailableOptions('ph1IKE')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
            </DefinitionList>
        </Grid.Item>
        <Grid.Item>
            <h5>PHASE 2</h5>
            <DefinitionList>
                <DefinitionList.Item>
                    <SelectField
                        label="Phase 2 ESP Encryption"
                        className="full-width"
                        {...stateFormHandler().ph2ESPEncryp}
                        value={getSelectValue('ph2ESPEncryp')}
                        onChange={(e) => handleStateFormChangeSup('ph2ESPEncryp', e)}
                        options={getAvailableOptions('ph2ESPEncryp')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Authentication"
                        className="full-width"
                        {...stateFormHandler().ph2Authentication}
                        value={getSelectValue('ph2Authentication')}
                        onChange={(e) => handleStateFormChangeSup('ph2Authentication', e)}
                        options={getAvailableOptions('ph2Authentication')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Diffie-Hillman Group"
                        className="full-width"
                        {...stateFormHandler().ph2DHGroup}
                        value={getSelectValue('ph2DHGroup')}
                        onChange={(e) => handleStateFormChangeSup('ph2DHGroup', e)}
                        options={getAvailableOptions('ph2DHGroup')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Phase 2 Timeout (Lifetime seconds)"
                        className="full-width"
                        {...stateFormHandler().ph2TimeoutSec}
                        value={getSelectValue('ph2TimeoutSec')}
                        onChange={(e) => handleStateFormChangeSup('ph2TimeoutSec', e)}
                        options={getAvailableOptions('ph2TimeoutSec')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Phase 2 Timeout (Lifetime KBytes)"
                        className="full-width"
                        {...stateFormHandler().ph2TimeoutKb}
                        value={getSelectValue('ph2TimeoutKb')}
                        onChange={(e) => handleStateFormChangeSup('ph2TimeoutKb', e)}
                        options={getAvailableOptions('ph2TimeoutKb')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <SelectField
                        label="Enable PFS"
                        className="full-width"
                        {...stateFormHandler().ph2EnablePFS}
                        value={getSelectValue('ph2EnablePFS')}
                        onChange={(e) => handleStateFormChangeSup('ph2EnablePFS', e)}
                        options={getAvailableOptions('ph2EnablePFS')}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
            </DefinitionList>
        </Grid.Item>
    </>
    )
}

export default StandardSiteToSiteVPNConfigurationForm;